import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import Lesson from "./Lesson";
import "./Playlist.css";
import { motion } from "framer-motion";
// import map from "../../assets/map.jpg";
// import { GoPlay } from "react-icons/go";
import Vimeo from "@u-wave/react-vimeo";


const containerPlaylist = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  hiddenleft: {
    opacity: 0,
    x: "-100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition: {
      type: "spring",
      stiffness: 80,
    },
  },
};

const Playlist = ({ courses }) => {
  const [videoData, setVideoData] = useState([]);
  const [firstLes, setFirstLes] = useState("");

  const handleLesson = (id) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/lesson/${id}/course/${courses._id}`, {
      method: "GET",
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        setVideoData(res.msg);
        // console.log(res)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const firstLesson = courses?.lessons[0]?._id;
    fetch(`${process.env.REACT_APP_BASE_URL}/lesson/${firstLesson}/course/${courses._id}`, {
      method: "GET",
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        // setVideoData(res.msg);
        console.log("res", res);
        setFirstLes(res.msg.video.split("/")[3]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [courses]);

  if (!firstLes) {
    return (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    );
  }

  return (
    <div className="playlist">
      <motion.div
        className="playlist-left"
        variants={containerPlaylist}
        initial="hiddenleft"
        animate="visible"
      >
        <h2>Course Details</h2>
        <div className="playlist-details">
          <Vimeo
            video={
              videoData.video
                ? `${videoData.video?.split("/")[3]}`
                : `${firstLes}`
            }
            height="440"
            width="770"
          />

          {/* <img src={map} className="img-fluid rounded" alt="map" />
          <motion.span whileHover={{ scale: 1.05 }}>
            <GoPlay />
          </motion.span> `691180937` */}
        </div>
        <h3>{courses.name}</h3>
      </motion.div>

      <motion.div
        className="playlist-right"
        variants={containerPlaylist}
        initial="hidden"
        animate="visible"
      >
        <h2>Course Playlist</h2>
        <div className="all-lessons">
          {courses.lessons?.map((les, index) => (
            <Lesson les={les} key={index} handleLesson={handleLesson} />
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Playlist;
